module.exports = __webpack_public_path__ + "img/h-page4-18.b29ef262.png";